export class Menu {
    MenuId: string;
    MenuName: string;
    ParentId: string;
    NavigateUrl: string;
    TargetName: string;
    Language: string;
    ImageUrl: string;
    ModuleId: string;
    MenuLevel: number;
    isDropdownOpen : boolean;
    IsFolder: boolean;
    IsOperational: boolean;
    SubMenu: Menu[];
    constructor() {
        this.SubMenu = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/data/models/base/menu.ts